import { useEffect } from "react";

/*
  Subtle scroll-in reveal (8px fade-up) using IntersectionObserver — no scroll
  listeners. Honors prefers-reduced-motion by leaving all content visible.
  Re-runs on route change so newly mounted content is observed.
*/
export default function useScrollReveal(pathname) {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReduced || !("IntersectionObserver" in window)) {
      return undefined;
    }

    document.documentElement.classList.add("reveal-ready");

    let observer;
    // Wait one frame so the newly-mounted route content is in the DOM.
    const raf = requestAnimationFrame(() => {
      const els = document.querySelectorAll("main .container");
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("in-view");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: "0px 0px -5% 0px" }
      );
      els.forEach((el) => observer.observe(el));
    });

    return () => {
      cancelAnimationFrame(raf);
      if (observer) observer.disconnect();
    };
  }, [pathname]);
}
